import { Record } from 'immutable';

export const TipRecord = Record({
  id: undefined,
  isRefunded: 0,
  stylist: undefined,
  stylistID: undefined,
  value: 0
});
